import React from 'react';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import ReactMapboxGl, { Marker } from 'react-mapbox-gl';
import Popup from './Popup.component';
import history from "../../helper/history";
import marker from "./../../asset/images/icon/marker-red-16.png";

const Map = ReactMapboxGl({
  accessToken:
      'pk.eyJ1IjoibWVocmRhZGcxMSIsImEiOiJja2xjdWRldTMwYXBvMm5uMTcwbGFxbG82In0.DLf8vvkzDG-IyOoxH1eFKw'
});

class Mapbox extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedProperty: null,
      zoom: 12
    }
  }

  selectProperty = (property = null) => {
    this.setState({ selectedProperty: property });
  };

  showDetail() {
    const { selectedProperty } = this.state;
    history.push(`/advanced-search/${selectedProperty.id}${history.location.search}`);
  }

  render() {
    const { centerCoordinator = ['51.394987', '35.711555'], onClick, properties = [], pickable = true } = this.props;
    const { selectedProperty, zoom } = this.state;

    return (
      <div style={{position: 'relative', height: '100%'}}>
        <Map
            style="mapbox://styles/mehrdadg11/ckhv6hl4f03ke19ok269d94x2"
            containerStyle={{
              height: '100%',
              width: '100%'
            }}
            center={centerCoordinator}
            zoom={[zoom]}
            onClick={(event, location) => {
              this.selectProperty();
              onClick && onClick(location.lngLat.lng, location.lngLat.lat);
            }}
            onZoom={(map, event) => {
              this.setState({zoom: map.getZoom()})
            }}
        >
          {
            selectedProperty && Object.keys(selectedProperty).length && (
                <Popup
                    property={selectedProperty}
                    onClick={() => {
                      this.showDetail()
                    }}
                    closePopup={() => this.selectProperty()}
                />
            )
          }
          {
            properties.map((property, index) => {
              return (
                <Marker key={index} coordinates={property.location.coordinates}>
                  <img onClick={() => this.selectProperty(property)} src={marker}/>
                </Marker>
              )
            })
          }
          {
            pickable && (
                <Marker coordinates={centerCoordinator}>
                  <img src={marker}/>
                </Marker>
            )
          }
        </Map>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({});

export default connect(undefined, mapDispatchToProps)(withRouter(Mapbox));
